(function(){
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const scrim = () => $('[data-scrim]');

  /* ---------- money ---------- */
  function formatMoney(cents){
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const v = (cents/100);
    const withDelims = (n, dec, t, d) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(d);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch(key){
        case 'amount_no_decimals': return withDelims(v, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(v, 0, '.', ',');
        default: return withDelims(v, 2, ',', '.');
      }
    });
  }

  /* ---------- panels ---------- */
  function closeAll(){
    $$('.drawer.is-open, .srch.is-open').forEach(el => { el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); });
    scrim() && scrim().classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function open(el){
    if(!el) return;
    closeAll();
    el.classList.add('is-open'); el.setAttribute('aria-hidden','false');
    scrim() && scrim().classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-open]');
    if(t){ e.preventDefault(); const el = document.getElementById(t.dataset.open); open(el); if(el && el.id === 'SearchOverlay'){ setTimeout(()=>{ const i = $('input', el); i && i.focus(); }, 200); runSearch(''); } }
    if(e.target.closest('[data-close]') || e.target.matches('[data-scrim]')) closeAll();
    if(!e.target.closest('.nav__item')) $$('.nav__item.is-open').forEach(x => x.classList.remove('is-open'));
  });
  document.addEventListener('keydown', e => { if(e.key === 'Escape'){ closeAll(); $$('.nav__item.is-open').forEach(x => x.classList.remove('is-open')); } });

  /* ---------- menus (click / keyboard) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('.nav__item > button.nav__link');
    if(!b) return;
    const item = b.parentElement, isOpen = item.classList.contains('is-open');
    $$('.nav__item.is-open').forEach(x => { x.classList.remove('is-open'); const bt = $('button', x); bt && bt.setAttribute('aria-expanded','false'); });
    if(!isOpen){ item.classList.add('is-open'); b.setAttribute('aria-expanded','true'); }
  });

  /* ---------- rails ---------- */
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-rail]');
    if(!a) return;
    const rail = document.getElementById(a.dataset.rail);
    if(rail) rail.scrollBy({ left: rail.clientWidth * 0.8 * Number(a.dataset.dir || 1), behavior: 'smooth' });
  });

  /* ---------- counters ---------- */
  function initCounters(root=document){
    const els = $$('[data-count]', root);
    if(!els.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if(!en.isIntersecting) return;
      const el = en.target; io.unobserve(el);
      const to = Number(el.dataset.count) || 0, suffix = el.dataset.suffix || '';
      if(reduce){ el.textContent = to.toLocaleString() + suffix; return; }
      let n = 0; const inc = Math.max(1, Math.ceil(to / 45));
      const step = () => { n += inc; if(n >= to){ el.textContent = to.toLocaleString() + suffix; return; } el.textContent = n.toLocaleString(); requestAnimationFrame(step); };
      step();
    }), { threshold: .4 });
    els.forEach(el => io.observe(el));
  }

  /* ---------- video posters ---------- */
  document.addEventListener('click', e => {
    const p = e.target.closest('[data-video-src]');
    if(!p) return;
    const f = document.createElement('iframe');
    f.src = p.dataset.videoSrc; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = p.dataset.videoTitle || 'Video';
    p.replaceWith(f);
  });

  /* ---------- predictive search ---------- */
  let searchTimer;
  function runSearch(q){
    const res = $('[data-search-results]'), head = $('[data-search-head]');
    if(!res) return;
    if(!q){ head.textContent = head.dataset.default || 'Popular right now'; res.innerHTML = res.dataset.defaultHtml || res.innerHTML; if(!res.dataset.defaultHtml) res.dataset.defaultHtml = res.innerHTML; return; }
    if(!res.dataset.defaultHtml) res.dataset.defaultHtml = res.innerHTML;
    const url = `${window.theme.routes.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`;
    fetch(url).then(r => r.json()).then(data => {
      const items = (data.resources && data.resources.results && data.resources.results.products) || [];
      head.textContent = items.length ? `${items.length} result${items.length === 1 ? '' : 's'}` : `No results for "${q}"`;
      res.innerHTML = items.map(p => `<a class="mcard" href="${p.url}"><div class="mcard__media">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : `<span>${escapeHtml(p.title).slice(0,24)}</span>`}</div><div class="mcard__t"><b>${escapeHtml(p.title)}</b><span>${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></div></a>`).join('');
    }).catch(() => {});
  }
  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  document.addEventListener('input', e => {
    if(!e.target.matches('[data-search-input]')) return;
    clearTimeout(searchTimer);
    const q = e.target.value.trim();
    searchTimer = setTimeout(() => runSearch(q), 220);
  });

  /* ---------- localization auto-submit ---------- */
  document.addEventListener('change', e => { if(e.target.matches('[data-autosubmit]')) e.target.form.submit(); });

  /* ---------- quantity ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]');
    if(!b) return;
    const input = b.parentElement.querySelector('input');
    const min = Number(input.min || 0), cur = Number(input.value || 0);
    input.value = Math.max(min, cur + Number(b.dataset.qty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product: variants + gallery ---------- */
  function initProduct(root){
    const dataEl = $('[data-product-json]', root);
    if(!dataEl || root.dataset.init) return;
    root.dataset.init = '1';
    const product = JSON.parse(dataEl.textContent);
    const formId = root.dataset.formId;
    const idInput = document.querySelector(`#${formId} input[name="id"]`);
    const priceEl = $('[data-price]', root);
    const btn = document.querySelector(`#${formId} [name="add"]`);
    const btnText = btn ? btn.querySelector('span') : null;
    const skuEl = $('[data-sku]', root);
    const stockEl = $('[data-stock]', root);

    function selectedOptions(){
      return $$('[data-option-index]', root).map(group => {
        const checked = group.querySelector('input:checked');
        const sel = group.querySelector('select');
        return checked ? checked.value : sel ? sel.value : null;
      });
    }
    function updateAvailability(opts){
      $$('[data-option-index]', root).forEach(group => {
        const idx = Number(group.dataset.optionIndex);
        group.querySelectorAll('input').forEach(inp => {
          const test = opts.slice(); test[idx] = inp.value;
          const ok = product.variants.some(v => v.available && v.options[idx] === inp.value && v.options.slice(0, idx).every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
        const label = group.querySelector('legend span');
        const checked = group.querySelector('input:checked');
        if(label && checked) label.textContent = checked.value;
      });
    }
    function onChange(){
      const opts = selectedOptions();
      const variant = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      updateAvailability(opts);
      if(!variant){
        if(btn){ btn.disabled = true; btnText.textContent = btn.dataset.unavailable; }
        return;
      }
      if(idInput){ idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if(priceEl){
        let html = `<span>${formatMoney(variant.price)}</span>`;
        if(variant.compare_at_price && variant.compare_at_price > variant.price){
          const off = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          html += `<s>${formatMoney(variant.compare_at_price)}</s><em>-${off}%</em>`;
        }
        priceEl.innerHTML = html;
      }
      if(btn){ btn.disabled = !variant.available; btnText.textContent = variant.available ? btn.dataset.add : btn.dataset.soldout; }
      if(skuEl) skuEl.textContent = variant.sku ? `SKU: ${variant.sku}` : '';
      if(stockEl){ stockEl.textContent = variant.available ? stockEl.dataset.in : stockEl.dataset.out; stockEl.classList.toggle('stock--out', !variant.available); }
      if(variant.featured_media) showMedia(root, variant.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, sectionId: root.dataset.sectionId } }));
    }
    root.addEventListener('change', e => { if(e.target.closest('[data-option-index]')) onChange(); });
    updateAvailability(selectedOptions());

    root.addEventListener('click', e => {
      const t = e.target.closest('[data-thumb]');
      if(t) showMedia(root, t.dataset.thumb);
    });
  }
  function showMedia(root, id){
    $$('.gallery__slide', root).forEach(s => s.classList.toggle('is-active', s.dataset.mediaId == id));
    $$('[data-thumb]', root).forEach(t => t.classList.toggle('is-active', t.dataset.thumb == id));
  }

  /* ---------- cart page ---------- */
  document.addEventListener('change', e => {
    if(!e.target.matches('[data-cart-qty]')) return;
    clearTimeout(e.target._t);
    e.target._t = setTimeout(() => e.target.form.submit(), 500);
  });

  /* ---------- newsletter / toast ---------- */
  window.themeToast = function(msg){
    const t = $('[data-toast]'); if(!t) return;
    t.textContent = msg; t.classList.add('is-open');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-open'), 2200);
  };

  function initAll(root=document){
    initCounters(root);
    $$('[data-product-section]', root).forEach(initProduct);
  }
  document.addEventListener('DOMContentLoaded', () => initAll());
  if(document.readyState !== 'loading') initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
